import React, { useState } from 'react'
import { Line } from 'react-chartjs-2';
import {
    Card,
    CardContent,
    CardHeader,
    makeStyles,
    Grid,
    Button,
    TextField,
    FormControl,
    Dialog,
    DialogContent,
    DialogActions
} from '@material-ui/core'
// import palette from '../../../../theme/palette';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import {options} from './chart'

import TableBranch from './TableBranch'

// require ('./roundedBar.js')

const useStyles = makeStyles(theme => ({
    root: {
        overflow: 'auto',
        height: '440px',
        marginBottom: theme.spacing(1)
    },
    text: {
        color: '#000000',
        fontFamily: 'Nunito'
    }
}))

const CardNumbers = props => {
    const classes = useStyles()
    const {
        chartName,
        // label,
        yearYearly,
        setYearYearly,
        branchGrafikYearly,
        setBranchGrafikYearly,
        grafikYearlyStatistic
    } = props

    var data = {}

    function month(string) {
        var monthNames = ["Januari","Februari","Maret","April","Mei","Juni",'Juli',"Agustus","September","Oktober","November","Desember"];
        return monthNames[string - 1];
    }
    
    // if(!loadingBarChartList && barChartList[`${barchart.id}`]){
    let tanggal = []
    let valueAOG = []
    let valueMOG = []

    for (let index = 0; index < grafikYearlyStatistic.length; index++) {
        tanggal.push(month(grafikYearlyStatistic[index].bulan))
        valueAOG.push(grafikYearlyStatistic[index].daftar_aog)
        valueMOG.push(grafikYearlyStatistic[index].daftar_mog)
    }

        
    // }

    data = {
        labels: tanggal,
        // labels: label,
        datasets: [
          {
            label : 'Agent of Gold',
            data: valueAOG,
            // data: [100,200,300,400,200,320,400,250,700,500,800,400],
            fill: false,
            backgroundColor: 'rgb(255, 99, 132)',
            borderColor: 'rgba(255, 99, 132, 0.2)',
            yAxisID: 'y-axis-1',  
          },
          {
            label : 'Member of Gold',
            data: valueMOG,
            // data: [200,100,400,230,150,190,20,25,70,50,80,40],
            fill: false,
            backgroundColor: 'rgb(54, 162, 235)',
            borderColor: 'rgba(54, 162, 235, 0.2)',
            yAxisID: 'y-axis-2',
          }
        ]
    };

    
    const handleYear = (date) => {
        const all = moment(date).format('YYYY');
        console.log(all)
        setYearYearly(yearYearly => ({
            ...yearYearly,
            submit: {
                submit: all
            },
            view: {
                view: date
            }
        }));
    };

    const handleChangeBranch = (event) => {
        setBranchGrafikYearly({
            id: event.id,
            name: event.name
        })
    }

    // Dialog Branch
	const [ openDialogBranch, setOpenDialogBranch ] = useState(false)
    
    return(
        <div>
            <Card className={classes.root}>
                <CardHeader 
                    title={chartName}
                    classes={{
                        title: classes.text
                    }}
                />
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item>
                            <FormControl className={classes.formControl}>
                                {/* <InputLabel htmlFor="age-native-simple">Pilih Cabang</InputLabel> */}
                                {/* <Select
                                    native
                                    value={branchGrafikYearly}
                                    onChange={handleChangeBranch}
                                    inputProps={{
                                        name: 'branch',
                                    }}
                                >
                                    <option value='' aria-label="None">All Branch</option>
                                    {statisticBranch.data.map(item => (
                                        <option value={item.id}>{item.name}</option>
                                    ))}
                                </Select> */}
                                <TextField
                                    value={branchGrafikYearly.name}
                                    onClick={() => setOpenDialogBranch(true)}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker 
                                    fullWidth
                                    // label="Tahun"
                                    variant="outlined"
                                    name="end_date"
                                    views={["year"]}
                                    format="yyyy"
                                    value={yearYearly.view.view} 
                                    onChange={handleYear} 
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardContent>
                    <Line
                        width={400} 
                        height={200}
                        data={data}
                        options={options}
                    />
                </CardContent>
            </Card>
            <Dialog
                open={openDialogBranch}
                onClose={() => setOpenDialogBranch(false)}
            >
                <DialogContent>
                    <TableBranch handleChangeBranch={handleChangeBranch} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialogBranch(false)}>
                        Batal
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default CardNumbers